export const NOTES = "NOTES";
export const ATTACHMENTS = "ATTACHMENTS";
export const LOCATION = "LOCATION";
export const URLS = "URLS";
export const HIDE = "HIDE";
